const STRING_VALIDATION_PROPERTIES = [
  "maxLength",
  "minLength",
  "pattern",
  "format",
  "enum"
];
const NUMBER_VALIDATION_PROPERTIES = [
  "maximum",
  "minimum",
  "multipleOf",
  "enum"
];
const INTEGER_VALIDATION_PROPERTIES = [
  "maximum",
  "minimum",
  "multipleOf",
  "enum"
];
const BOOLEAN_VALIDATION_PROPERTIES = ["enum"];
const validationPropertiesSet = /* @__PURE__ */ new Set([
  ...STRING_VALIDATION_PROPERTIES,
  ...NUMBER_VALIDATION_PROPERTIES,
  ...INTEGER_VALIDATION_PROPERTIES,
  ...BOOLEAN_VALIDATION_PROPERTIES
]);
const isSchemaValidationProperty = (keyword) => {
  return validationPropertiesSet.has(keyword);
};
export {
  BOOLEAN_VALIDATION_PROPERTIES,
  INTEGER_VALIDATION_PROPERTIES,
  NUMBER_VALIDATION_PROPERTIES,
  STRING_VALIDATION_PROPERTIES,
  isSchemaValidationProperty
};
//# sourceMappingURL=schema-validation-properties.js.map
